import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const getMemberClasses = params => {
  return api.get(`admin/member-classes`, {
    params,
  });
};

export const getMemberClassesQueryOptions = (params, meta) => {
  return queryOptions({
    queryKey: ["member-classes", params],
    queryFn: () => getMemberClasses(params),
    meta,
  });
};

export const useMemberClassesQuery = ({
  queryConfig = {},
  meta = {},
  ...params
}) => {
  return useQuery({
    ...getMemberClassesQueryOptions(params, meta),
    ...queryConfig,
  });
};
